export const testType = {
    "test_type": "ການທົດສອບ",
    "practice_type": "ບົດເຝິກຫັດ",
    "exam_type": "ສອບເສັງ",
    "multiple_choice": "ຫຼາຍທາງເລືອກ",
    "voted": "ໂຫວດ",
    "survey": "ສຳຫຼວດ",
    "multiple_choice_comparison": "ການປຽບທຽບການທົດສອບ",
    "multiple_choice_script" : "ເນື້ອໃນບົດທົດສອບ",
    "multiple_choice_test": "ຈັດລຽງຄະແນນການທົດສອບ",
};

